import React from 'react';

const NoRecordFound = ({ 
  message = 'No records found', 
  subMessage = 'We couldn\'t find any data matching your current filters or search terms.',
  icon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  )
}) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center bg-gray-50/50 rounded-sm border border-gray-200 w-full my-2">
    <div className="bg-white shadow-sm border border-gray-200 rounded-full p-4 mb-4">
      {icon}
    </div>
    <h3 className="text-[16px] font-semibold text-gray-900 mb-1.5 tracking-tight">
      {message}
    </h3>
    <p className="text-[13px] text-gray-500 max-w-sm leading-relaxed">
      {subMessage}
    </p>
  </div>
);

export default NoRecordFound;